import { render, staticRenderFns } from "./AnomalyModal.vue?vue&type=template&id=72af6e26&scoped=true&"
import script from "./AnomalyModal.vue?vue&type=script&lang=js&"
export * from "./AnomalyModal.vue?vue&type=script&lang=js&"
import style0 from "./AnomalyModal.vue?vue&type=style&index=0&id=72af6e26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af6e26",
  null
  
)

export default component.exports